const homeHeroSliderPrevBtn = document.querySelector('#home-hero-slider__prev-btn');
const homeHeroSliderNextBtn = document.querySelector('#home-hero-slider__next-btn');
const homeHeroSlider = new Splide('#home-hero-slider', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    pagination: false,
    arrows: false,    
    rewind: false,
    gap: 0,
    padding: {
        left: '0px',
        right: '200px'
    },
    breakpoints: {
        1280: {
            padding: {
                left: '0px',
                right: '0px'
            }
        },
        768: {
            padding: {
                left: '0px',
                right: '0px'
            }
        }
    }
}).mount()

const homeBestSellersPrevBtn = document.querySelector('#home-best-sellers__prev-btn');
const homeBestSellersNextBtn = document.querySelector('#home-best-sellers__next-btn');
const homeBestSellersSlider = new Splide('#home-best-sellers-slider', {
    type: 'loop',
    perPage: 4,
    perMove: 4,
    start: 0,
    gap: 30,
    rewind: false,
    pagination: false,
    arrows: false,
    padding: {
        left: '0',
        right: '100px'
    },
    breakpoints: {
        1280: {
            perPage: 3,
            perMove: 3,
            gap: 30,
            padding: {
                left: '30px',
                right: '100px'
            }
        },
        768: {
            perPage: 2,
            perMove: 2,
            gap: 30,
            padding: {
                left: '30px',
                right: '100px'
            }
        },
        640: {
            perPage: 1,
            perMove: 1,
            gap: 30,
            padding: {
                left: '20px',
                right: '100px'
            }
        }
    }
}).mount()

const homeFeaturedArticlesPrevBtn = document.querySelector('#home-featured-articles__prev-btn');
const homeFeaturedArticlesNextBtn = document.querySelector('#home-featured-articles__next-btn');

const homeFeaturedArticlesSlider = new Splide('#home-featured-articles-slider' , {
    type: 'carousel',
    perPage: 2,
    perMove: 2,
    focus: 0,
    gap: 30,
    rewind: false,    
    pagination: false,
    arrows: false,
    padding: {
        left: '20px',
        right: '150px'
    },
    breakpoints: {
        1280: {
            perPage: 2,
            perMove: 2,
            gap: 20,
            padding: {
                left: '40px',
                right: '150px'
            }
        },
        768: {
            perPage: 1,
            perMove: 1,
            gap: 40,
            padding: {
                left: '40px',
                right: '100px'
            }
        },
        420: {
            perPage: 1,
            perMove: 1,
            gap: 20,
            padding: {
                left: '20px',
                right: '50px'
            }
        }
    }
}).mount()

homeHeroSliderNextBtn.addEventListener('click', function() {
    homeHeroSlider.go('>')
})
homeHeroSliderPrevBtn.addEventListener('click', function() {
    homeHeroSlider.go('<')
})

homeBestSellersNextBtn.addEventListener('click', function() {
    homeBestSellersSlider.go('>')
})
homeBestSellersPrevBtn.addEventListener('click', function() {
    homeBestSellersSlider.go('<')
})

homeFeaturedArticlesNextBtn.addEventListener('click', function() {
    homeFeaturedArticlesSlider.go('>')
})
homeFeaturedArticlesPrevBtn.addEventListener('click', function() {
    homeFeaturedArticlesSlider.go('<')
})